export default __webpack_public_path__ + "static/media/photo_gallery_2.7a36be84.png";